module.exports = __webpack_public_path__ + "static/media/featured_img.4018af0f.png";